/**
 * useLocalMatchFile — share the operator's local match-video File across
 * BBB and QC tabs via IndexedDB, so QC can play a per-ball "clip" by seeking
 * the local video to start_ms..end_ms — INSTANTLY, before the S3 upload +
 * MediaConvert slicer have run.
 *
 * One File per match (keyed by match_id). The File object is persisted via
 * IDB (which natively supports Blob/File). On QC mount we read it back and
 * synthesize a blob URL for the <video> element.
 *
 * Cleared on explicit clearLocalMatchFile() — e.g. when the slicer has
 * finished and S3 clips are live, we don't need the local fallback anymore.
 */
const IDB_DB = "zcd_local_match_file_v1";
const IDB_STORE = "files";

function idbOpen() {
  return new Promise((res, rej) => {
    const r = indexedDB.open(IDB_DB, 1);
    r.onupgradeneeded = () => r.result.createObjectStore(IDB_STORE, { keyPath: "match_id" });
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
}

export async function saveLocalMatchFile(matchId, file) {
  if (!matchId || !file) return;
  const db = await idbOpen();
  const tx = db.transaction(IDB_STORE, "readwrite");
  tx.objectStore(IDB_STORE).put({
    match_id: matchId,
    file_blob: file,
    file_name: file.name,
    file_size: file.size,
    saved_at: Date.now(),
  });
  return new Promise(r => tx.oncomplete = r);
}

export async function loadLocalMatchFile(matchId) {
  if (!matchId) return null;
  const db = await idbOpen();
  return new Promise(res => {
    const tx = db.transaction(IDB_STORE, "readonly");
    const req = tx.objectStore(IDB_STORE).get(matchId);
    req.onsuccess = () => res(req.result || null);
    req.onerror = () => res(null);
  });
}

export async function clearLocalMatchFile(matchId) {
  if (!matchId) return;
  const db = await idbOpen();
  const tx = db.transaction(IDB_STORE, "readwrite");
  tx.objectStore(IDB_STORE).delete(matchId);
  return new Promise(r => tx.oncomplete = r);
}
